/* eslint-disable */ import { memoEval, sceneEntityObjectPropertiesComponent, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const drawer33Door66Components = [
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'body', true).withEntity('Drawer33Door66').attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/jms.glb',
            objectName: 'CABINET_LYNX_2DDH_PO_FDH_3D_BODY',
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'drawer', true).withEntity('Drawer33Door66').attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/jms.glb',
            objectName: 'CABINET_FRONT_PANEL',
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'drawerHandle', true).withEntity('Drawer33Door66').attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/jms.glb',
            objectName: 'CABINET_HANDLE',
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'body', true).withEntity('Drawer33Door66').attach(memoEval((self)=>[
            self.$width
        ], ($width)=>({
            morphTargetInfluences: {
                Width: {
                    value: $width,
                    scaleZero: 12 * 25.4,
                    scaleOne: 24 * 25.4
                }
            }
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'drawer', true).withEntity('Drawer33Door66').attach(memoEval((self)=>[
            self.$drawerOffsetX,
            self.$drawerOffsetY,
            self.$width,
            self.$doorModelWidthScaleZero,
            self.$doorModelWidthScaleOne,
            self.$drawerHeight,
            self.$doorModelHeightScaleZero,
            self.$doorModelHeightScaleOne
        ], ($drawerOffsetX, $drawerOffsetY, $width, $doorModelWidthScaleZero, $doorModelWidthScaleOne, $drawerHeight, $doorModelHeightScaleZero, $doorModelHeightScaleOne)=>({
            offsetX: $drawerOffsetX,
            offsetY: $drawerOffsetY,
            morphTargetInfluences: {
                Width: {
                    value: $width,
                    scaleZero: $doorModelWidthScaleZero,
                    scaleOne: $doorModelWidthScaleOne
                },
                Length: {
                    value: $drawerHeight,
                    scaleZero: $doorModelHeightScaleZero,
                    scaleOne: $doorModelHeightScaleOne
                }
            }
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'drawerHandle', true).withEntity('Drawer33Door66').attach(memoEval((self)=>[
            self.$drawerHandleOffsetX,
            self.$drawerHandleOffsetY,
            self.$handleOffsetZ,
            self.$handleLength,
            self.$handleModelScaleZero,
            self.$handleModelScaleOne
        ], ($drawerHandleOffsetX, $drawerHandleOffsetY, $handleOffsetZ, $handleLength, $handleModelScaleZero, $handleModelScaleOne)=>({
            offsetX: $drawerHandleOffsetX,
            offsetY: $drawerHandleOffsetY,
            offsetZ: $handleOffsetZ,
            rotationZ: Math.PI / 2,
            morphTargetInfluences: {
                Length: {
                    value: $handleLength,
                    scaleZero: $handleModelScaleZero,
                    scaleOne: $handleModelScaleOne
                }
            }
        })))
];

//# sourceMappingURL=drawer-33-door-66.js.map